import React from "react";

function MessageReactions({ reactions = [], onReact }) {

  const grouped = reactions.reduce((acc, r) => {
    acc[r.emoji] = (acc[r.emoji] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="reaction-wrapper">
      <div className="current-reactions">
        {Object.entries(grouped).map(([emoji, count]) => (
          <span 
            key={emoji} 
            className="reaction-badge" 
            onClick={() => onReact(emoji)} 
          >
            {emoji} <small>{count > 1 ? count : ""}</small>
          </span>
        ))}
      </div>
      
    </div>
  );
}

export default MessageReactions;